import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Select from "react-select";
import { useSelector } from "react-redux";
import { edit } from "../Constant/Index";

const PhysicianInfo = () => {
  const userDetail = useSelector((state) => state?.Auth?.users);
  const parsedData = JSON.parse(userDetail?.specialization);

  const specializationOptions = [
    { value: "pediatrics", label: "Pediatrics" },
    { value: "neurology", label: "Neurology" },
    { value: "adnarology", label: "adnarology" },
    { value: "sharicology", label: "sharicology" },
    { value: "adnarology1", label: "adnarology1" },
    { value: "sharicology1", label: "sharicology1" },
  ];

  const [selectedSpecializations, setSelectedSpecializations] = useState(
    "Area of Specialization"
  );

  const handleChange = (selectedOptions) => {
    setSelectedSpecializations(selectedOptions);
  };

  return (
    <>
      <Header />
      <PageHeader pagename="Physician Profile" />
      <section className="main-sidebar  user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PhysicianProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="row">
                  <div className="col-md-6">
                    <div className="main-heading d-flex align-items-center gap-3 mb-3">
                      <div className="edit-btn back">
                        <div className="nav-anchor"></div>
                      </div>
                      <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
                        Personal Info
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      style={{
                        float: "right",
                      }}
                      className="main-heading d-flex align-items-center gap-3 mb-3"
                    >
                      <div className="edit-btn back">
                        <Link to="/physician-profile-edit">
                          <div className="nav-anchor">
                            <img src={edit} alt="Edit" className="img-fluid" />
                          </div>
                        </Link>
                      </div>
                      <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
                        Edit Personal Info
                      </h5>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="signup-wrapper edit-shifts-main">
                      <form>
                        <div className="row mb-5">
                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                First Name
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.first_name}
                              </p>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                Last Name
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.last_name}
                              </p>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                Email
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.email}
                              </p>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                Phone Number
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.phone}
                              </p>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                Address
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.address}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                Specialization
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                Degree title
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.degree_title}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                License Number
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.license_number}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                City
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.city}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                State
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.state}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="personal_info_time">
                              <label className="main-heading level-7 mb-0 main-heading-font dark-color">
                                Zip Code
                              </label>
                              <p className="level-9 mb-0 primary-medium-font extra-color-12">
                                {userDetail?.zip_code}
                              </p>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PhysicianInfo;
